<template>
    <div class="w-full">
        <header class="mb-6 flex items-end justify-between gap-4">
            <div>
                <p class="mb-1 text-xs font-semibold uppercase tracking-[0.2em] text-nomad-accent">Listen together</p>
                <h1 class="text-3xl font-bold tracking-tight text-white md:text-4xl">Playlists</h1>
                <p class="mt-2 text-sm text-nomad-300 md:text-base">Curated collections of songs</p>
            </div>
            <span v-if="playlists?.total" class="pb-1 text-sm text-nomad-400">
                {{ playlists.total }} collections
            </span>
        </header>

        <ul v-if="playlists?.data?.length" class="grid grid-cols-1 gap-3">
            <li v-for="playlist in playlists.data" :key="playlist.id">
                <Link
                    :title="playlist.name"
                    :href="'/playlist/' + playlist.id"
                    class="group flex items-center gap-3 rounded-xl bg-nomad-800 p-3 transition-all duration-300 hover:bg-nomad-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-nomad-accent sm:gap-4 sm:p-4"
                >
                    <img
                        :src="playlist.cover"
                        :alt="playlist.name + ' cover'"
                        class="h-16 w-16 shrink-0 rounded-lg object-cover transition-transform duration-300 group-hover:scale-105 sm:h-20 sm:w-20"
                        loading="lazy"
                    />
                    <div class="min-w-0 flex-1">
                        <h2 class="truncate text-base font-semibold text-white sm:text-lg">
                            {{ playlist.name }}
                        </h2>
                        <p class="mt-1 text-sm text-nomad-300">
                            {{ playlist.songs_count ?? 0 }} {{ playlist.songs_count === 1 ? 'song' : 'songs' }}
                        </p>
                    </div>
                    <span class="icon-chevron-right shrink-0 text-nomad-400 transition-transform group-hover:translate-x-1 group-hover:text-nomad-accent" aria-hidden="true"></span>
                </Link>
            </li>
        </ul>

        <div v-else class="rounded-xl bg-nomad-900 px-6 py-16 text-center">
            <span class="icon-music mb-4 inline-block text-3xl text-nomad-500" aria-hidden="true"></span>
            <h2 class="text-lg font-semibold text-white">No playlists yet</h2>
            <p class="mt-2 text-sm text-nomad-300">Check back later for curated song collections.</p>
        </div>
    </div>
</template>
<script setup>
defineProps({ playlists: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage, Link } from "@inertiajs/vue3";

export default {
    methods: {
        ...mapActions("playlists", ["getAllPlaylist"]),
    },
    beforeMount() {
        document.title = 'Playlists - Music Collection'
    },
    components: {
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    }
};
</script>
